import th, { v0 } from '@tillhub/javascript-sdk'
import { getBaseUrl } from '@shared/utils/baseUrlProvider.js'
import { getClientAccountId } from './client-account-id.js'

export function isViewingSwitchedDashboard() {
  const primary = getClientAccountId()
  const active = globalThis.localStorage.getItem('clientAccountId')
  return !!(primary && active && active !== primary)
}

/**
 * IAM profile is stored under the home tenant. On a child dashboard, use an
 * IamUsers handler scoped to the home tenant without re-initialising the SDK.
 */
export async function fetchIamUserProfile(userId) {
  if (!userId || typeof userId !== 'string') {
    return null
  }

  if (!isViewingSwitchedDashboard()) {
    return th.iamUsers().profile(userId)
  }

  const baseUrl = await getBaseUrl()
  const iamUsers = new v0.IamUsers(
    { base: baseUrl, user: getClientAccountId() },
    th.http
  )
  return iamUsers.profile(userId)
}
